import { PATHS } from 'shared/utils/paths'

import type { CtaSchema, LinkTypeSchema } from './types'

export const getCMSCtaLinkParams = (cta: CtaSchema) => {
  if (cta?.link) {
    return { ...getCMSLinkParams(cta.link), text: cta.text }
  }

  // deprecated flow
  return {
    href:
      cta.type === 'internal-link'
        ? cta?.internalLink || ''
        : cta.type === 'external-link'
          ? cta?.externalLink || ''
          : buildDocumentHref(cta?.file?.slug?.current),
    text: cta.text
  }
}

export const getCMSLinkParams = (link: LinkTypeSchema) => {
  return {
    href:
      link.type === 'internal-link'
        ? link?.internalLink || ''
        : link.type === 'external-link'
          ? link.externalLink || ''
          : buildDocumentHref(link.file?.slug?.current),
    text: ''
  }
}

// In static mode, map document links to local PDFs in /public/static.
// Convention: /static/mamyito-<slug>.pdf
export const buildDocumentHref = (slug?: string) => {
  const safeSlug = slug || ''

  return PATHS.documents.replace('[slug]', safeSlug)
}

export const getDocHref = (slug: { current: string }) => {
  return PATHS.documents.replace('[slug]', slug.current)
}
